import axios from 'axios';
import { loadingActions } from '../redux/actions';
import { Store } from '../redux/stores';
import { HEXtoBlackOrWhite } from './colors';

export const getFriends = async (userId) => {
    Store.dispatch(loadingActions.loadingStart('friends.getList'));
    try {
        let resp = await axios.get(process.env.REACT_APP_HOST + '/profile/friendlist');

        if (resp.data.payload && resp.data.payload.friends) {
            for(let i in resp.data.payload.friends) {
                resp.data.payload.friends[i].fgColor = HEXtoBlackOrWhite(resp.data.payload.friends[i].color);
            }
        }
        if (resp.data.payload && resp.data.payload.pending) {
            for(let i in resp.data.payload.pending) {
                resp.data.payload.pending[i].fgColor = HEXtoBlackOrWhite(resp.data.payload.pending[i].color);
            }
        }
        
        Store.dispatch(loadingActions.loadingEnd('friends.getList'));

        return resp.data;
    } catch (e) {
        Store.dispatch(loadingActions.loadingEnd('friends.getList'));
        return e.response.data;
    }
};


export const getFriendsListPage = async () => {
    Store.dispatch(loadingActions.loadingStart('friends.getFriendsListPage'));
    try {
        let resp = await axios.get(process.env.REACT_APP_HOST + '/profile/friends/');

        if (resp && resp.data && resp.data.payload) {
            for (let i in resp.data.payload) {  
                if (resp.data.payload.hasOwnProperty(i)) {
                    resp.data.payload[i] = resp.data.payload[i].length ? resp.data.payload[i].map(f => ({...f, fgColor: HEXtoBlackOrWhite(f.color)})) : [];
                }
            }
        }

        Store.dispatch(loadingActions.loadingEnd('friends.getFriendsListPage'));
        return resp.data;
    } catch (e) {
        Store.dispatch(loadingActions.loadingEnd('friends.getFriendsListPage'));
        return e.response ? e.response.data : {};
    }
};

export const getProfileFind = async (filter) => {
    Store.dispatch(loadingActions.loadingStart('friends.getProfileFind'));
    try {
        let resp = await axios.post(process.env.REACT_APP_HOST + '/profile/find', {filter});

        if (resp && resp.data && resp.data.payload) {
            for (let i in resp.data.payload) {  
                resp.data.payload[i].fgColor = HEXtoBlackOrWhite(resp.data.payload[i].color) ?? "#fff";
            }
        }

        Store.dispatch(loadingActions.loadingEnd('friends.getProfileFind'));
        return resp.data;
    } catch (e) {
        Store.dispatch(loadingActions.loadingEnd('friends.getProfileFind'));
        return e.response ? e.response.data : {};
    }
};

export const getBlockedUsers = async () => {
    Store.dispatch(loadingActions.loadingStart('friends.getBlockedUsers'));
    try {
        let resp = await axios.get(process.env.REACT_APP_HOST + '/profile/blocked');

        if (resp && resp.data && resp.data.payload) {
            for (let i in resp.data.payload) {  
                resp.data.payload[i].fgColor = HEXtoBlackOrWhite(resp.data.payload[i].color ?? '#000000') ?? "#fff";
            }
        }

        Store.dispatch(loadingActions.loadingEnd('friends.getBlockedUsers'));
        return resp.data;
    } catch (e) {
        Store.dispatch(loadingActions.loadingEnd('friends.getBlockedUsers'));
        return e.response ? e.response.data : {};
    }
};

export const getUserProfile = async (id) => {
    Store.dispatch(loadingActions.loadingStart('friends.getUserProfile'));
    try {
        let resp = await axios.get(process.env.REACT_APP_HOST + '/profile/'+id);
        
        Store.dispatch(loadingActions.loadingEnd('friends.getUserProfile'));

        return resp.data;
    } catch (e) {
        Store.dispatch(loadingActions.loadingEnd('friends.getUserProfile'));
        return e.response.data;
    }
};

export const requestFriendship = async (id) => {
    Store.dispatch(loadingActions.loadingStart('friends.requestFriendship'));
    try {
        let resp = await axios.post(process.env.REACT_APP_HOST + '/profile/friends/invite/'+id);
        
        Store.dispatch(loadingActions.loadingEnd('friends.requestFriendship'));

        return resp.data;
    } catch (e) {
        Store.dispatch(loadingActions.loadingEnd('friends.requestFriendship'));
        return e.response.data;
    }
};

export const acceptFriendRequest = async (id) => {
    Store.dispatch(loadingActions.loadingStart('friends.acceptFriendRequest'));
    try {
        let resp = await axios.post(process.env.REACT_APP_HOST + '/profile/friends/confirm/'+id);
        
        Store.dispatch(loadingActions.loadingEnd('friends.acceptFriendRequest'));

        return resp.data;
    } catch (e) {
        Store.dispatch(loadingActions.loadingEnd('friends.acceptFriendRequest'));
        return e.response ? e.response.data : e;
    }
};

export const cancelFriendRequest = async (id) => {
    Store.dispatch(loadingActions.loadingStart('friends.acceptFriendRequest'));
    try {
        let resp = await axios.delete(process.env.REACT_APP_HOST + '/profile/friends/remove/'+id);
        
        Store.dispatch(loadingActions.loadingEnd('friends.acceptFriendRequest'));

        return resp.data;
    } catch (e) {
        Store.dispatch(loadingActions.loadingEnd('friends.acceptFriendRequest'));
        return e.response ? e.response.data : e;
    }
};

export const blockUser = async (id) => {
    Store.dispatch(loadingActions.loadingStart('friends.blockUser'));
    try {
        let resp = await axios.post(process.env.REACT_APP_HOST + '/profile/friends/block/'+id);
        
        Store.dispatch(loadingActions.loadingEnd('friends.blockUser'));

        return resp.data;
    } catch (e) {
        Store.dispatch(loadingActions.loadingEnd('friends.blockUser'));
        return e.response ? e.response.data : e;
    }
};

export const denouceUser = async (id, reason, note) => {
    Store.dispatch(loadingActions.loadingStart('friends.blockUser'));
    try {
        let resp = await axios.post(process.env.REACT_APP_HOST + '/profile/friends/denouce/'+id, {reason, note});
        
        Store.dispatch(loadingActions.loadingEnd('friends.blockUser'));

        return resp.data;
    } catch (e) {
        Store.dispatch(loadingActions.loadingEnd('friends.blockUser'));
        return e.response ? e.response.data : e;
    }
};

export const unblockUser = async (id) => {
    Store.dispatch(loadingActions.loadingStart('friends.blockUser'));
    try {
        let resp = await axios.post(process.env.REACT_APP_HOST + '/profile/friends/unblock/'+id);
        
        Store.dispatch(loadingActions.loadingEnd('friends.blockUser'));

        return resp.data;
    } catch (e) {
        Store.dispatch(loadingActions.loadingEnd('friends.blockUser'));
        return e.response ? e.response.data : e;
    }
};